<template>
    <div>
        <div
            ref="card"
            class="px-5 py-4 border transition-colors duration-300 ease-in-out"
            :class="{
                'border-secondary-500': !focus,
                'border-primary-500': focus,
            }"
        ></div>

        <div v-if="message" class="alert alert-secondary mt-4" role="alert">
            <p>{{ message }}</p>
        </div>

        <input v-if="paymentMethodId" type="hidden" name="paymentForm[stripe][paymentMethodId]" :value="paymentMethodId">
    </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js';

export default {
    props: {
        pk: {
            type: String,
            required: true,
        },
        secret: {
            type: String,
            default: '',
        },
        scenario: {
            type: String,
            default: 'payment',
        },
        params: {
            type: Object,
            required: true,
        },
    },

    emits: ['loading'],

    data() {
        return {
            stripe: null,
            card: null,
            focus: false,
            processing: false,
            message: null,
            paymentMethodId: null,
        };
    },

    computed: {
        form() {
            return this.$el.closest('form');
        },
    },

    async mounted() {
        this.stripe = await loadStripe(this.pk);

        switch (this.scenario) {
            case 'payment':
                this.displayPaymentForm();
                break;
            case '3ds':
                await this.perform3dsAuthentication();
                break;
        }
    },

    beforeUnmount() {
        this.form.removeEventListener('submit', this.onSubmitForm);
    },

    methods: {
        displayPaymentForm() {
            const elements = this.stripe.elements({
                fonts: [
                    {
                        cssSrc: 'https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;1,400&display=swap',
                    },
                ],
            });

            const style = {
                base: {
                    color: '#000',
                    iconColor: '#CAB180',
                    fontFamily: 'Lato, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#a0aec0',
                    },
                },
            };

            this.card = elements.create('card', {
                style,
                hidePostalCode: true,
            });

            this.card.mount(this.$refs.card);

            this.card.on('focus', () => {
                this.focus = true;
            });

            this.card.on('blur', () => {
                this.focus = false;
            });

            this.card.on('change', this.displayStripeMessage);

            this.form.addEventListener('submit', this.onSubmitForm);
        },
        async perform3dsAuthentication() {
            this.message = 'Please wait, processing payment...';
            const result = await this.stripe.handleCardPayment(this.secret, this.card);
            this.displayStripeMessage(result);

            if (result.error) {
                this.displayPaymentForm();
            } else {
                location.reload();
            }
        },
        async onSubmitForm(event) {
            event.preventDefault();

            if (this.processing) {
                return false;
            }

            this.processing = true;
            this.$emit('loading', true);

            if (this.secret) {
                await this.perform3dsAuthentication(this.card);
                return;
            }

            const paymentData = {
                /* eslint-disable-next-line camelcase */
                billing_details: this.params,
            };

            const result = await this.stripe.createPaymentMethod('card', this.card, paymentData);
            this.displayStripeMessage(result);

            if (result.error) {
                this.processing = false;
                this.$emit('loading', false);
            } else {
                this.paymentMethodId = result.paymentMethod.id;

                this.$nextTick(() => {
                    this.form.submit();
                });
            }
        },
        displayStripeMessage(event) {
            if (event.error) {
                this.message = event.error.message;
            } else {
                this.message = null;
            }
        },
    },
};
</script>
